<template>
  <div class="login-page">
    <background color="grayed" :game="gameBackground" />
    <Navigation :isSimple="true" />
    <div class="login-page__wrap">
      <!-- <AccountLogin v-if="!isMfa" @submit="login" @accountCreate="" /> -->
      <component
        :is="component"
        :key="component"
        v-if="!isMfa"
        @submit="login"
        @accountCreate="changeComponent('AccountCreate')"
        @accountLogin="changeComponent('AccountLogin')"
        @submitCreate="createAccount"
      ></component>
      <Mfa v-else :type="mfaType" @submitMfa="submitMfa" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import Navigation from "@/components/Navigation.vue";
import AccountLogin from "@/components/Onboarding/AccountLogin.vue";
import AccountCreate from "@/components/Onboarding/AccountCreate.vue";
import Mfa from "@/components/Mfa.vue";
import Gamepad from "@/utils/gamepadInit";

export default {
  components: {
    Navigation,
    AccountLogin,
    AccountCreate,
    Mfa
  },

  data() {
    return {
      isMfa: false,
      mfaType: null,
      component: "AccountLogin"
    };
  },

  computed: {
    ...mapState({
      cacheVersion: state => state.cacheVersion
    }),
    game() {
      return this.$route.query.game ? this.$route.query.game : "bg3";
    },
    gameBackground() {
      return this.$route.query.game
        ? `onboarding-${this.$route.query.game}`
        : "onboarding";
    }
  },

  methods: {
    changeComponent(componentName) {
      this.component = componentName;
      if (document.pad) {
        this.$nextTick(() => {
          document.pad.resetFocus();
        });
      }
    },
    login(form) {
      this.$store
        .dispatch("login", {
          email: form.email,
          password: form.password
        })
        .then(res => {
          if (res.status) {
            if (Object.prototype.hasOwnProperty.call(res.data, "mfa")) {
              this.isMfa = true;
              this.mfaType = res.data.mfa;
            } else if (Object.prototype.hasOwnProperty.call(res.data, "user")) {
              this.$store.dispatch("setUser", res.data.user);
              // window.location.replace("/");
              window.location.href = `/${this.game}?${this.cacheVersion}`;
            }
          }
        })
        .catch(() => {});
    },

    submitMfa(code) {
      switch (this.mfaType) {
        case "sms":
          this.$store
            .dispatch("loginMfaSms", { code })
            .then(res => {
              this.$store.dispatch("setUser", res.data.user);
              // window.location.replace("/");
              window.location.href = `/${this.game}?${this.cacheVersion}`;
            })
            .catch(() => {});
          break;

        case "totp":
          this.$store
            .dispatch("loginMfaTotp", { code })
            .then(res => {
              this.$store.dispatch("setUser", res.data.user);
              // window.location.replace("/");
              window.location.href = `/${this.game}?${this.cacheVersion}`;
            })
            .catch(() => {});
          break;
      }
    },

    createAccount(form) {
      this.$store
        .dispatch("create", form)
        .then(res => {
          if (res.status) {
            this.$store
              .dispatch("login", {
                email: form.email,
                password: form.password
              })
              .then(res => {
                if (res.status) {
                  if (Object.prototype.hasOwnProperty.call(res.data, "user")) {
                    this.$store.dispatch("setUser", res.data.user);
                    // window.location.replace("/");
                    window.location.href = `/${this.game}?${this.cacheVersion}`;
                  }
                }
              })
              .catch(() => {});
          }
        })
        .catch(() => {});
    }
  },

  mounted() {
    Gamepad();
  }
};
</script>

<style lang="scss" scoped>
.login-page {
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0 120px;

  &__wrap {
    width: 500px;
    margin: 20px auto 0 auto;
  }

  .create-account {
    height: calc(100vh - 137px);
    width: 600px;
    margin-left: -50px;
  }
}

@media screen and (max-height: 800px) {
  .login-page {
    .create-account {
      height: calc(100vh - 115px);
    }
  }
}
</style>
